// extracted by mini-css-extract-plugin
export default {"combined":"styles_combined__IpJ6Q"};